import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { expensesType_response } from "../../services/api/api";

// Models

export interface expensesTypeState {
    isLoaded: boolean,
    isLoading: boolean,
    isFetching: boolean,
    hasMore: boolean,
    expensesType:{ [k:number]: expensesType_response[]},
    page:number

}

const initialReceiptVouchersState: expensesTypeState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    expensesType: {},
    page:1
}

export const expensesTypesSlice = createSlice({
    name: 'expenses_type',
    initialState: initialReceiptVouchersState,
    reducers: {
        init: ( state, {payload}: PayloadAction<expensesType_response[]> ) => {
            //console.log('slicer',payload)
            state.expensesType[state.page] = payload
        },
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsFetching: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isFetching = payload
        },
        setHasMore: ( state, {payload}: PayloadAction<boolean> ) => {
            state.hasMore = payload
        },
        addExpensesType: ( state, {payload}: PayloadAction<expensesType_response[]> ) => {
            state.expensesType[state.page] =   state.expensesType[state.page]?
             [...state.expensesType[state.page],...payload ]:[...payload]
        },
        updateExpensesType: ( state, {payload}: PayloadAction<expensesType_response> ) => {
            let index = state.expensesType[state.page].findIndex( receiptVoucher => receiptVoucher.id === payload.id )
            if( index !== -1 )
                state.expensesType[state.page][index]=payload
        },
        deleteExpensesType: ( state, {payload}: PayloadAction<number[]> ) => {
            payload.map(id => {
                let index = state.expensesType[state.page].findIndex( receiptVoucher => receiptVoucher.id === id )
                if( index != -1 )
                    state.expensesType[state.page].splice( index, 1 )
            })
        },
        reset: ( state ) => {
            state.expensesType = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        }
    }
})